import React from 'react';
import { Box, Section } from '@common/components';
import { Row, Col, Typography } from 'antd';

const Ministry = ({ ministry, onClick }) => {
	return (
		<Box className="p-3">
			<Section className="mb-3" hoverable shadowed>
				<Row type="flex" className="login-links">
					<Col flex={1} onClick={() => onClick && onClick(ministry)}>
						<Typography.Title level={3}>
							{ministry.name}
						</Typography.Title>
						<Typography.Text level={3}>
							{ministry.description}
						</Typography.Text>
					</Col>
				</Row>
			</Section>
		</Box>
	);
};

export default Ministry;
